(() => {
  'use strict';
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('[data-product-image]');
    if (!thumbnail) return;
    const gallery = thumbnail.closest('.product-gallery');
    const image = gallery?.querySelector('.product-main-image img');
    if (!image) return;
    event.preventDefault();
    const preload = new Image();
    const request = thumbnail.dataset.productImage;
    gallery.dataset.requestedImage = request;
    preload.onload = () => {
      if (gallery.dataset.requestedImage !== request || !gallery.isConnected) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = request; image.alt = thumbnail.dataset.imageAlt || '';
      gallery.querySelectorAll('[data-product-image]').forEach(link => link.removeAttribute('aria-current'));
      thumbnail.setAttribute('aria-current', 'true');
      if (!matchMedia('(prefers-reduced-motion:reduce)').matches && image.animate) {
        image.getAnimations().forEach(animation => animation.cancel());
        image.animate([{opacity:.35},{opacity:1}],{duration:300});
      }
    };
    preload.src = request;
  });
})();
